import CheckoutMixins from './checkout'
import TimerMixins from './timer'
import LocationMixin from 'utils/vue/mixins/location'
import EventsMixin from 'utils/vue/mixins/events'
import CartMixin from 'utils/vue/mixins/cart'

export default {
  mixins: [LocationMixin, TimerMixins, CheckoutMixins, EventsMixin, CartMixin],
  created() {
    this.allowLocationCheckout(true)
  }
}
